import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Logo from '@/components/ui/Logo/Logo';

import { Wrapper } from './HeaderLogo.style';

const HeaderLogo = ({
  'data-test-subject': dataTestSubject,
  className,
  onClick,
}) => {
  return (
    <Wrapper
      className={cx('mrkt-head_logo', className)}
      onClick={onClick}
      data-test-subject={dataTestSubject}
      href="/">
      <Logo />
    </Wrapper>
  );
};

HeaderLogo.propTypes = {
  'data-test-subject': PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
};
HeaderLogo.defaultProps = {
  'data-test-subject': '',
  className: '',
  onClick: () => {},
};

export default HeaderLogo;
